import { render, staticRenderFns } from "./PaymentWithWallet.vue?vue&type=template&id=bf2247bc&scoped=true&"
import script from "./PaymentWithWallet.vue?vue&type=script&setup=true&lang=js&"
export * from "./PaymentWithWallet.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./PaymentWithWallet.vue?vue&type=style&index=0&id=bf2247bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf2247bc",
  null
  
)

export default component.exports